import React from "react";
import "./UnisexSalon.css";

const UnisexSalonHead = () => {
  return (
    <div className="unisexHeadContainer">
      <h2>Best Salon Services in Bangalore</h2>
      <div className="unisexUnderline"></div>
    </div>
  );
};

export default UnisexSalonHead;
